exports.listAll = function (state) {
  return state.locationsDB.allDocs({
    startkey: 'funder:',
    endkey: 'funder:\ufff0:',
    include_docs: true
  })
    .then(results => results.rows.filter(row => !row.error).map(row => row.doc))
}

exports.get = function (state, id) {
  return state.locationsDB.get(id)
}

exports.listByPrograms = async function (state, programIds) {
  if (!programIds || programIds.length === 0) {
    console.warn('Program ID(s) is required to list funders by program')
    return []
  }
  const programKeys = programIds.map(programId => {
    const programPath = `programs.${programId}`
    return {
      [programPath]: { $exists: true }
    }
  })
  try {
    const results = await state.locationsDB.find({
      selector: {
        _id: {
          $gte: 'funder:',
          $lte: 'funder:\ufff0'
        },
        $or: programKeys
      },
      limit: Number.MAX_SAFE_INTEGER
    })
    return results.docs
  } catch (error) {
    throw new Error(`Error listing funders by programs: ${error.message}`)
  }
}
